import React, { useEffect, useState } from "react";

const InstagramFeed = () => {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const username = "galaxybags_luggageworld";

  useEffect(() => {
    // Simulate API fetch with dummy data
    setIsLoading(true);
    setTimeout(() => {
      setPosts([
        {
          id: "1",
          caption: "New Arrival – Premium Travel Bag ✈️",
          media_url:
            "https://www.instagram.com/galaxybags_luggageworld/reel/DIszCJov-K-/",
          permalink: "https://www.instagram.com/galaxybags_luggageworld/",
        },
        {
          id: "2",
          caption: "Luxury Leather Backpack 🎒",
          media_url:
            "https://images.unsplash.com/photo-1620799138834-6a6c8cdd0b19?w=500&auto=format&fit=crop&q=60",
          permalink: "https://www.instagram.com/p/DUMMYPOST2/",
        },
        {
          id: "3",
          caption: "Stylish Handbag for Everyday Use 👜",
          media_url:
            "https://images.unsplash.com/photo-1600185365483-26d7e4e7f9d6?w=500&auto=format&fit=crop&q=60",
          permalink: "https://www.instagram.com/p/DUMMYPOST3/",
        },
        {
          id: "4",
          caption: "Travel Smart with Luggaelegacys 🌍",
          media_url:
            "https://images.unsplash.com/photo-1600180758895-7632fd982c77?w=500&auto=format&fit=crop&q=60",
          permalink: "https://www.instagram.com/p/DUMMYPOST4/",
        },
        {
          id: "5",
          caption: "Trendy Sling Bag for Daily Vibes 💼",
          media_url:
            "https://images.unsplash.com/photo-1585386959984-a4155223f3d1?w=500&auto=format&fit=crop&q=60",
          permalink: "https://www.instagram.com/p/DUMMYPOST5/",
        },
      ]);
      setIsLoading(false);
    }, 1000);
  }, []);

  return (
    <div className="w-full py-16 bg-white px-4">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8 text-center">
          <h2 className="text-xl md:text-2xl font-bold text-gray-800 tracking-wide">
            <a
              href={`https://www.instagram.com/${username}`}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline inline-flex items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="mr-2"
              >
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" x2="17.5" y1="6.5" y2="6.5" />
              </svg>
              EXPLORE #{username.toUpperCase()}
            </a>
          </h2>
        </div>

        {isLoading ? (
          <p className="text-center text-gray-500">Loading...</p>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
            {posts.map((post) => (
              <a
                key={post.id}
                href={post.permalink}
                target="_blank"
                rel="noopener noreferrer"
                className="relative block w-full overflow-hidden rounded-lg group"
              >
                <img
                  src={post.media_url}
                  alt={post.caption || "Instagram post"}
                  className="w-full h-full object-cover aspect-square transition-transform duration-300 group-hover:scale-105"
                />
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default InstagramFeed;
